module.exports = __webpack_public_path__ + "static/media/monomial-2.12433ba0.png";